export { isPointInPolygon } from './is-point-in-polygon';
export { isPolygonsIntersect } from './is-polygons-intersect';
//# sourceMappingURL=index.js.map